import PdfIcon from './pdf-icon'
import ExcelIcon from './excel-icon'
import WordIcon from './word-icon'
import DefaultIcon from './default-icon'
import { IDocument } from '~hooks/queries/documents/use-get-documents'

export const getFileIcon = (fileType: IDocument['fileType']) => {
  switch (fileType) {
    case 'pdf':
      return <PdfIcon />
    case 'xls':
    case 'xlsx':
    case 'xlsb':
      return <ExcelIcon />
    case 'doc':
    case 'docx':
      return <WordIcon />
    default:
      return <DefaultIcon />
  }
}
